module.exports = {
  path: ':reference',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/MyBookingShow'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/my_bookings/routes/show/index.js